import { Link } from 'react-router-dom';

const stats = [
  { number: '50万+', label: '月活跃用户' },
  { number: '2000+', label: '专业文章' },
  { number: '98%', label: '用户好评率' },
  { number: '30+', label: '认证专家' },
];

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-600/20 to-transparent"></div>
      <div className="absolute top-0 right-0 w-80 h-80 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/3"></div>

      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-8 mb-14">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-4xl font-bold text-white mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                {stat.number}
              </div>
              <div className="text-xs md:text-sm text-white/70">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            准备好开启更美好的亲密关系了吗？
          </h2>
          <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
            加入爱爱网社区，与我们一同探索健康、开放、负责任的亲密关系世界。
          </p>
          <Link
            to="/about"
            className="inline-flex px-8 py-3.5 rounded-lg bg-white text-primary-600 text-sm font-semibold hover:bg-white/95 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}